export default {"src":"/_next/static/media/close-icon.a00977c4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};